import classNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

// Simple Form Components
import SimpleFormNameFieldGroup from '../simple_form/SimpleFormNameFieldGroup';
import SimpleFormAddressFormGroup from '../simple_form/SimpleFormAddressFormGroup';
import SimpleFormDobFieldGroup from '../simple_form/SimpleFormDobFieldGroup';
import SimpleFormSSNFieldGroup from '../simple_form/SimpleFormSSNFieldGroup';

// Control Form Components (Deprecated)
import ControlFormNameFieldGroup from '../control_form/ControlFormNameFieldGroup';
import ControlFormAddressFormGroup from '../control_form/ControlFormAddressFormGroup';

import { addressValidate } from './validations';
import BaseAddressForm from './BaseAddressForm';
import ConfirmationModal from './ConfirmationModal';
import {
  getConfirmValues,
  getSsnOptoutValue,
  getDobValues,
} from '../../selectors';
import LogOutLink from '../LogOutLink';
import PropTypes from '../../propTypes';
import GenderFieldGroup from './GenderFieldGroup';
import { TranslatedMessage, TRANSLATED_CLASS } from 'common/components/Intl';

import * as f from 'common/components/Form';
import * as m from '../../messages';
import { FULL, ALTERNATE } from '../../constants';

export class AddressForm extends BaseAddressForm {
  static propTypes = {
    confirmationRequired: PropTypes.bool,
    confirmValues: PropTypes.object,
    descriptionMessageId: PropTypes.string,
    disableNameFields: PropTypes.bool,
    disableDobFields: PropTypes.bool,
    dobValues: PropTypes.object,
    initialValues: PropTypes.object,
    layout: PropTypes.oneOf([FULL, ALTERNATE]),
    minPurchaseAge: PropTypes.number,
    minRequiredAge: PropTypes.number,
    showAddressFields: PropTypes.bool,
    showDobFields: PropTypes.bool,
    showNameHeading: PropTypes.bool,
    showSSNFields: PropTypes.bool,
    ssnOptoutEnabled: PropTypes.bool,
    ssn_optout: PropTypes.bool,
    titleMessageId: PropTypes.string,
  };

  renderNameFields() {
    const NameFieldGroup = this.props.enableSimple
      ? SimpleFormNameFieldGroup
      : ControlFormNameFieldGroup;

    return (
      <NameFieldGroup
        showHeading={this.props.showNameHeading}
        disabled={this.props.disableNameFields}
      />
    );
  }

  renderDobFields() {
    return (
      <SimpleFormDobFieldGroup
        selectedValues={this.props.dobValues}
        minRequiredAge={this.props.minRequiredAge}
        minPurchaseAge={this.props.minPurchaseAge}
        disabled={this.props.disableDobFields}
      />
    );
  }

  renderAddressFormGroup() {
    const {
      showAddressFields,
      titleMessageId,
      descriptionMessageId,
      addressFieldsMeta,
      layout,
      enableSimple,
      initialValues,
    } = this.props;

    const { country } = initialValues || {};

    const AddressFormGroup = enableSimple
      ? SimpleFormAddressFormGroup
      : ControlFormAddressFormGroup;

    return (
      <AddressFormGroup
        showAddressFields={showAddressFields}
        titleMessageId={titleMessageId}
        descriptionMessageId={descriptionMessageId}
        addressFieldsMeta={addressFieldsMeta}
        onAddressSelect={this.onAddressSelect}
        selectedState={this.state.selectedState}
        layout={layout}
        country={country}
        renderNameFields={this.renderNameFields.bind(this)}
      />
    );
  }

  renderSSNFieldGroup() {
    const { national_id_number_type } = this.props.initialValues;
    const { ssn_optout, ssnOptoutEnabled } = this.props;

    return (
      <SimpleFormSSNFieldGroup
        type={national_id_number_type}
        disabled={ssn_optout}
        optOutEnabled={ssnOptoutEnabled}
      />
    );
  }

  render() {
    let gender;
    if (this.props.addressFieldsMeta) {
      gender = this.props.addressFieldsMeta.filter(
        meta => meta.field === 'gender'
      )[0];
    }

    return (
      <>
        <f.Form className="AddressForm" onSubmit={this.submitHandler}>
          {this.props.showDobFields && this.renderDobFields()}

          {this.props.layout === FULL && this.renderNameFields()}

          {gender && <GenderFieldGroup options={gender.labels_and_values} />}

          {this.renderAddressFormGroup()}

          {this.props.showSSNFields && this.renderSSNFieldGroup()}

          {this.props.error && (
            <div
              id="errors"
              className={classNames('red label', TRANSLATED_CLASS)}
            >
              {this.props.error}

              <p>
                <TranslatedMessage
                  id={m.FAIL_CONTACT_INFO}
                  values={{ support_link_text: this.supportLink() }}
                />
              </p>
            </div>
          )}

          <f.Submit
            className="AddressForm__submit"
            isSubmitting={this.props.submitting}
          >
            <TranslatedMessage id={m.ADDRESS_SUBMIT} />
          </f.Submit>

          <LogOutLink />
        </f.Form>

        {this.props.confirmationRequired && (
          <ConfirmationModal
            isOpen={this.state.modalIsOpen}
            formValues={this.props.confirmValues}
            onConfirm={this.onConfirm.bind(this)}
            onClose={this.hideConfirmationModal.bind(this)}
          />
        )}
      </>
    );
  }
}

const Form = reduxForm({
  form: 'age_verification',
  validate: addressValidate,
})(AddressForm);

// Decorate with connect to read form values to be used by confirmation dialog
// and ssn disabling.
export default connect(state => ({
  confirmValues: getConfirmValues(state, 'age_verification'),
  ssn_optout: getSsnOptoutValue(state, 'age_verification'),
  dobValues: getDobValues(state, 'age_verification'),
}))(Form);
